/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListingReference
 */
export interface ListingReference {
    /**
     * 
     * @type {string}
     * @memberof ListingReference
     */
    mlsId: string;
    /**
     * 
     * @type {string}
     * @memberof ListingReference
     */
    mlsSource: string;
}

/**
 * Check if a given object implements the ListingReference interface.
 */
export function instanceOfListingReference(value: object): value is ListingReference {
    if (!('mlsId' in value) || value['mlsId'] === undefined) return false;
    if (!('mlsSource' in value) || value['mlsSource'] === undefined) return false;
    return true;
}

export function ListingReferenceFromJSON(json: any): ListingReference {
    return ListingReferenceFromJSONTyped(json, false);
}

export function ListingReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListingReference {
    if (json == null) {
        return json;
    }
    return {
        
        'mlsId': json['mlsId'],
        'mlsSource': json['mlsSource'],
    };
}

export function ListingReferenceToJSON(json: any): ListingReference {
    return ListingReferenceToJSONTyped(json, false);
}

export function ListingReferenceToJSONTyped(value?: ListingReference | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mlsId': value['mlsId'],
        'mlsSource': value['mlsSource'],
    };
}

